import React, { useState, useEffect } from 'react';
import { RichText } from '@sitecore-jss/sitecore-jss-react';
import classnames from 'classnames';
import { ThemeEnum } from '../../utils/enums';
import './video.scss';

const Video = ({ fields, params }) => {
    const { VideoURL, Caption, AltText } = fields;
    const { Theme } = params;
    const [playerURL, setPlayerURL] = useState('');
    const oEmbedURL = 'https://vimeo.com/api/oembed.json?url=';
    const videoBlock = 'zn-video';

    useEffect(() => {
        const activeGroups = window?.OnetrustActiveGroups?.split(',').filter(Boolean);
        const videoId = VideoURL?.value;

        if (!videoId) {
            setPlayerURL('');
            return;
        }
        const fetchPlayerURL = async () => {
            try {
                let dnt = '';
                if (!['C0004', 'C0003'].every((group) => activeGroups?.includes(group))) {
                    dnt += '?dnt=1';
                }
                const response = await fetch(`${oEmbedURL}${videoId}${dnt}`);
                const result = await response.json();
                let url = `https://player.vimeo.com/video/${result?.video_id}${dnt}`;

                setPlayerURL(url);
            } catch (error) {
                setPlayerURL('');
            }
        };

        fetchPlayerURL();
    }, [VideoURL]);

    return (
        <figure
            className={classnames(`${videoBlock}`, {
                [`${videoBlock}--dark`]: Theme === ThemeEnum.dark,
            })}
        >
            <div className="zn-video__media">
                <iframe
                    title={AltText?.value}
                    src={playerURL}
                    frameBorder="0"
                    allowFullScreen
                ></iframe>
            </div>
            <figcaption className="zn-video__caption">
                <RichText field={Caption} />
            </figcaption>
        </figure>
    );
};

export default Video;
